class UserIcon extends HTMLElement {
  constructor() {
    super()
    this['logged-in'] = false
    this.avatar = ''
  }

  connectedCallback() {
    const shadow = this.attachShadow({ mode: 'open' })
    const template = document.getElementById('user-icon').content.cloneNode(true)
    const container = template.querySelector('.user-icon-container')

    if (this["logged-in"] === 'true' || this["logged-in"] === true) {
      container.classList.add('loggedIn')
    } else {
      container.classList.remove('loggedIn')
    }

    if(this.avatar) {
      container.innerHTML = `<img src='${this.avatar}' alt="user's icon" />`
    }

    shadow.appendChild(template)
  }

  attributeChangedCallback(property, oldValue, newValue) {
    if (oldValue === newValue) {
      return
    }

    this[property] = newValue
  }

  static get observedAttributes() {
    return ['logged-in', 'avatar']
  }
}

customElements.define('user-icon', UserIcon)